import { Avatar, Button, Card, Collapse, Image, Tag } from "antd";
import {
  ArrowRightIcon,
  CrossIcon,
  PencilIcon,
  PlusIcon,
} from "../../../../../../atoms/CustomIcons";
import { ServiceLineListingType, SubServiceType } from "../../../ducks/types";
import { useNavigate } from "react-router-dom";
import { CaretRightOutlined } from "@ant-design/icons";
import { getInitials } from "../../../../../../config/utils";

interface PropsType {
  data: ServiceLineListingType | SubServiceType | null | undefined;
  serviceLineDetail: ServiceLineListingType | null;
  companyId: string;
  activeType: string | null;
  setActiveId: React.Dispatch<React.SetStateAction<string | null>>;
  setActiveRecord: React.Dispatch<React.SetStateAction<SubServiceType | null>>;
  setActiveType: React.Dispatch<React.SetStateAction<string | null>>;
}

export default function SidebarDetail(props: PropsType) {
  const {
    data,
    setActiveId,
    companyId,
    serviceLineDetail,
    activeType,
    setActiveRecord,
    setActiveType,
  } = props;
  const navigate = useNavigate();

  return (
    <div className="innerRight">
      {data?.id ? (
        <>
          <div className="innerRightBox">
            <h4 className="titleBar">
              {activeType === "simpleSubService"
                ? "Subservice details"
                : "Service details"}
              <div className="btns_action">
                <Button
                  onClick={() =>
                    navigate(
                      `/company-settings/edit-service/${data?.id}/${data?.service_line_id}/${data?.company_id}`
                    )
                  }
                  icon={<PencilIcon />}
                />
                <Button
                  type="text"
                  icon={<CrossIcon />}
                  onClick={() => {
                    setActiveId(null);
                    setActiveRecord(null);
                    setActiveType(null);
                  }}
                />
              </div>
            </h4>
          </div>
          <Card className="innerImageCard">
            <div className="image_tag">
              <Image
                src={data?.image_url || "/images/company/no_image_grey.png"}
                preview={false}
              />
              {/* <Avatar
                src={data?.image_url}
                shape="square"
                style={{ width: "100%", height: "120px" }}
              /> */}
              <Tag
                className={
                  data?.service_provision_type === "in_house"
                    ? "violet_tag defaultTag typeLabel"
                    : "orange_tag defaultTag typeLabel"
                }
              >
                {data?.service_provision_type === "in_house"
                  ? "In-house"
                  : "Subcontracted"}
              </Tag>
            </div>
            <div
              style={{ marginBottom: data?.type === "subservice" ? 0 : "16px" }}
            >
              <h5>{data?.name}</h5>
              {data?.description && (
                <p
                  style={{
                    fontSize: "12px",
                    lineHeight: "16px",
                    marginTop: "6px",
                  }}
                >
                  {data?.description}
                </p>
              )}
            </div>

            {data?.type !== "subservice" && (
              <>
                {data?.frequency !== "one_time" && (
                  <div style={{ marginBottom: "16px" }}>
                    <h6
                      style={{
                        fontSize: "12px",
                        lineHeight: "16px",
                        fontWeight: "500",
                        marginBottom: "4px",
                      }}
                    >
                      Frequency
                    </h6>
                    <h6
                      style={{
                        fontSize: "14px",
                        lineHeight: "20px",
                        fontWeight: "700",
                      }}
                    >
                      {data?.frequency === "bi_weekly" ? (
                        "Bi-weekly"
                      ) : (
                        <span style={{ textTransform: "capitalize" }}>
                          {data?.frequency}
                        </span>
                      )}
                    </h6>
                  </div>
                )}

                <div>
                  <h6
                    style={{
                      fontSize: "12px",
                      lineHeight: "16px",
                      fontWeight: "500",
                      marginBottom: "4px",
                    }}
                  >
                    Quantity unit
                  </h6>
                  <h6
                    style={{
                      fontSize: "14px",
                      lineHeight: "20px",
                      fontWeight: "700",
                    }}
                  >
                    {data?.unit?.singular_name || data?.unit?.name ? (
                      <>
                        {data?.unit?.singular_name}{" "}
                        {data?.unit?.name ? `(${data?.unit?.name})` : ""}
                      </>
                    ) : data?.takeoff?.unit?.singular_name ||
                      data?.takeoff?.unit?.name ? (
                      <>
                        {data?.takeoff?.unit?.singular_name}{" "}
                        {data?.takeoff?.unit?.name
                          ? `(${data?.takeoff?.unit?.name})`
                          : ""}
                      </>
                    ) : (
                      "-"
                    )}
                  </h6>
                </div>
              </>
            )}
          </Card>

          {data?.type !== "subservice" && (
            <>
              <Card>
                <Collapse
                  items={[
                    {
                      key: "1",
                      label: "Labor",
                      children: (
                        <div className="card_collapse">
                          <p style={{ fontSize: 12, marginBottom: 4 }}>
                            Production rate
                          </p>
                          <p style={{ marginBottom: 0 }}>
                            <b>{data?.production_rate ?? "-"}</b>{" "}
                            <span style={{ color: "#6C7478", fontWeight: 600 }}>
                              {data?.unit?.singular_name
                                ? data?.unit?.singular_name
                                : data?.takeoff?.unit?.singular_name}
                              /hr
                            </span>
                          </p>
                        </div>
                      ),
                    },
                  ]}
                  defaultActiveKey={["1"]}
                  expandIcon={({ isActive }) => (
                    <CaretRightOutlined rotate={isActive ? 265 : 90} />
                  )}
                />
              </Card>
              {data?.service_provision_type === "in_house" && (
                <>
                  <Card>
                    <Collapse
                      items={[
                        {
                          key: "1",
                          label: "Materials",
                          children: (
                            <div className="card_collapse">
                              {data?.serviceMaterials?.length > 0 ? (
                                <>
                                  {data?.serviceMaterials?.some(
                                    (e: { material_category_id: string }) =>
                                      e?.material_category_id
                                  ) && (
                                    <div
                                      className="mat_sidebar_wrap"
                                      style={{
                                        borderBottom: "1px solid #EFF2F3",
                                        paddingBottom: 16,
                                      }}
                                    >
                                      <div className="material_sidebar_top">
                                        <span style={{ width: "50%" }}>
                                          Category
                                        </span>
                                        <span style={{ width: "50%" }}>
                                          Use rate
                                        </span>
                                      </div>
                                      {data?.serviceMaterials?.map(
                                        (e: {
                                          material_category_id: string;
                                          use_rate: number;
                                          material_category: {
                                            name: string;
                                            color: string;
                                          };
                                          material: {
                                            unit: { singular_name: string };
                                          };
                                        }) => {
                                          return (
                                            e?.material_category_id && (
                                              <div className="mat_sidebar_cat">
                                                <span style={{ width: "50%" }}>
                                                  <Tag
                                                    className={
                                                      e?.material_category
                                                        ?.color
                                                    }
                                                  >
                                                    {e?.material_category?.name}
                                                  </Tag>
                                                </span>
                                                <span
                                                  style={{ width: "50%" }}
                                                  className="bold_text"
                                                >
                                                  {e?.use_rate}{" "}
                                                  <span
                                                    style={{
                                                      fontSize: 12,
                                                      color: "#6C7478",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    {data?.takeoff?.unit
                                                      ?.singular_name
                                                      ? `${data?.takeoff?.unit?.singular_name}/${e?.material?.unit?.singular_name}`
                                                      : `${data?.unit?.singular_name}/${e?.material?.unit?.singular_name}`}
                                                  </span>
                                                </span>
                                              </div>
                                            )
                                          );
                                        }
                                      )}
                                    </div>
                                  )}

                                  {data?.serviceMaterials?.some(
                                    (e: { material_id: string }) =>
                                      e?.material_id
                                  ) && (
                                    <div className="mat_sidebar_wrap">
                                      <div className="material_sidebar_top">
                                        <span style={{ width: "50%" }}>
                                          Material name
                                        </span>
                                        <span style={{ width: "50%" }}>
                                          Use rate
                                        </span>
                                      </div>
                                      {data?.serviceMaterials?.map(
                                        (e: {
                                          material_id: string;
                                          use_rate: number;
                                          material: {
                                            name: string;
                                            unit: { singular_name: string };
                                          };
                                        }) => {
                                          return (
                                            e?.material_id && (
                                              <div className="mat_sidebar_cat">
                                                <span
                                                  style={{ width: "50%" }}
                                                  className="bold_text"
                                                >
                                                  {e?.material?.name}
                                                </span>
                                                <span
                                                  style={{ width: "50%" }}
                                                  className="bold_text"
                                                >
                                                  {e?.use_rate}{" "}
                                                  <span
                                                    style={{
                                                      fontSize: 12,
                                                      color: "#6C7478",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    {data?.takeoff?.unit
                                                      ?.singular_name
                                                      ? `${data?.takeoff?.unit?.singular_name}/${e?.material?.unit?.singular_name}`
                                                      : `${data?.unit?.singular_name}/${e?.material?.unit?.singular_name}`}
                                                  </span>
                                                </span>
                                              </div>
                                            )
                                          );
                                        }
                                      )}
                                    </div>
                                  )}
                                </>
                              ) : (
                                <Card className="no_data_add_btn">
                                  There are no materials
                                  <Button
                                    className="outlined-btn btn-sm"
                                    onClick={() =>
                                      navigate(
                                        `/company-settings/edit-service/${data?.id}/${data?.service_line_id}/${data?.company_id}`
                                      )
                                    }
                                  >
                                    <PlusIcon /> Add
                                  </Button>
                                </Card>
                              )}
                            </div>
                          ),
                        },
                      ]}
                      expandIcon={({ isActive }) => (
                        <CaretRightOutlined rotate={isActive ? 265 : 90} />
                      )}
                    />
                  </Card>
                  <Card>
                    <Collapse
                      items={[
                        {
                          key: "1",
                          label: "Equipment",
                          children: (
                            <div className="card_collapse">
                              {data?.serviceEquipments?.length > 0 ? (
                                data?.serviceEquipments?.map(
                                  (e: {
                                    id: string;
                                    equipment: { name: string };
                                  }) => (
                                    <Tag key={e?.id} style={{ marginRight: 4 }}>
                                      {e?.equipment?.name}
                                    </Tag>
                                  )
                                )
                              ) : (
                                <Card className="no_data_add_btn">
                                  There is no equipment
                                  <Button
                                    className="outlined-btn btn-sm"
                                    onClick={() =>
                                      navigate(
                                        `/company-settings/edit-service/${data?.id}/${data?.service_line_id}/${data?.company_id}`
                                      )
                                    }
                                  >
                                    <PlusIcon /> Add
                                  </Button>
                                </Card>
                              )}
                            </div>
                          ),
                        },
                      ]}
                      expandIcon={({ isActive }) => (
                        <CaretRightOutlined rotate={isActive ? 265 : 90} />
                      )}
                    />
                  </Card>
                </>
              )}
            </>
          )}
        </>
      ) : (
        <>
          <Card>
            <h4> Production managers </h4>

            {serviceLineDetail?.userServiceLines &&
            serviceLineDetail?.userServiceLines?.length > 0 ? (
              <>
                <Avatar.Group
                  max={{
                    count: 5,
                  }}
                >
                  {serviceLineDetail?.userServiceLines?.map(
                    (e: {
                      user: {
                        image_url: string;
                        first_name: string;
                        last_name: string;
                      };
                    }) => (
                      <>
                        {e?.user?.image_url ? (
                          <Avatar size={28} src={e?.user?.image_url} />
                        ) : (
                          <Avatar size={28}>
                            {getInitials(
                              e?.user?.first_name,
                              e?.user?.last_name
                            )}
                          </Avatar>
                        )}
                      </>
                    )
                  )}
                </Avatar.Group>
                <br />
                <Button
                  className="outlined-btn btn-sm"
                  style={{ marginTop: 16 }}
                  onClick={() =>
                    navigate(`/company-settings/employees/${companyId}`)
                  }
                >
                  <PencilIcon /> Edit managers
                </Button>
              </>
            ) : (
              <>
                <p> Visit “Employees” to assign managers. </p>
                <Button
                  className="outlined-btn btn-sm"
                  onClick={() =>
                    navigate(`/company-settings/employees/${companyId}`)
                  }
                >
                  Assign managers <ArrowRightIcon />
                </Button>
              </>
            )}
          </Card>
          <Card>
            <h4> Crews </h4>
            <p>Visit “Crews” page to add them.</p>
            <Button
              className="outlined-btn btn-sm"
              onClick={() => navigate(`/crews/${companyId}`)}
            >
              Add crews <ArrowRightIcon />
            </Button>
          </Card>
          <Card>
            <h4> Labor rate </h4>
            <p>Visit “Labor rates” page settings to set it up.</p>
            <Button
              className="outlined-btn btn-sm"
              onClick={() =>
                navigate(`/company-settings/labor-hourly-rates/${companyId}`)
              }
            >
              Set labor rates <ArrowRightIcon />
            </Button>
          </Card>
        </>
      )}
    </div>
  );
}
